import { useParams, Link } from 'react-router-dom';
import { POLICIES, FOOTER_LINKS } from '../data/policies';
import { Footer } from '../components/Footer';

export function LegalPage() {
  const { slug } = useParams<{ slug: string }>();
  const policy = slug ? POLICIES[slug] : undefined;

  if (!policy) {
    return (
      <div className="legal-wrap">
        <div className="legal-card">
          <h1>Page not found</h1>
          <p>The policy page you are looking for does not exist.</p>
          <Link className="btn btn-primary" to="/">Back to home</Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="legal-wrap">
      <div className="legal-hero">
        <Link className="legal-back" to="/">← Back to IAMMUZIK</Link>
        <h1 className="legal-title">{policy.title}</h1>
        <p className="legal-updated">Last updated: {policy.updated}</p>
      </div>

      <div className="legal-card">
        {policy.intro && <p className="legal-intro">{policy.intro}</p>}
        {policy.sections.map((s, i) => (
          <section key={i} className="legal-section">
            <h2>{s.heading}</h2>
            {s.paragraphs?.map((p, j) => <p key={j}>{p}</p>)}
            {s.bullets && (
              <ul>
                {s.bullets.map((b, k) => <li key={k}>{b}</li>)}
              </ul>
            )}
          </section>
        ))}
      </div>

      <div className="legal-toc">
        <h3>Other policies</h3>
        <div className="legal-toc-links">
          {FOOTER_LINKS.filter((l) => l.slug !== policy.slug).map((l) => (
            <Link key={l.slug} to={`/legal/${l.slug}`}>{l.title}</Link>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}
